import { createFileRoute } from "@tanstack/react-router";
import Login from "@/auth/sign-in";

export const Route = createFileRoute("/(root)/root-user/login")({
  component: () => <Login isSuperadmin={true} />,
});
